import { render, staticRenderFns } from "./BasicAppBar.vue?vue&type=template&id=99b570e0&scoped=true&"
import script from "./BasicAppBar.vue?vue&type=script&lang=js&"
export * from "./BasicAppBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b570e0",
  null
  
)

export default component.exports